import React from 'react';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { Spinner } from '@/components/ui/spinner';

export const SubRowDaysLoading: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const t = useNamespacedTranslation('components.timeSheetsTable');
  return (
    <div className="d-flex align-items-center ms-4">
      <span className="me-2">{t('loadingDays')}</span>
      <Spinner animation="border" size="sm" />
    </div>
  );
};
